import Marquee from "react-fast-marquee";

const ITEMS = [
  "Scaffolding",
  "Formwork",
  "Cuplock",
  "Adjustable Props",
  "H Frames",
  "Steel Planks",
  "Centring Sheets",
  "Base Jacks",
  "Made in Bengaluru",
];

export const EditorialMarquee = () => (
  <div className="bg-navy py-8 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((t) => (
        <span key={t} className="flex items-center">
          <span className="font-heading text-4xl md:text-6xl font-black uppercase tracking-tighter text-outline-white px-8 whitespace-nowrap">
            {t}
          </span>
          <span className="w-3 h-3 bg-silver inline-block shrink-0" />
        </span>
      ))}
    </Marquee>
  </div>
);
